import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
/**
 * @class DisputeTransactionType
 * @classdesc Class definition for the record type from model
 * @param {OBJECT} record - The record from the model to init class
 * @extends BCMSRecord
 * @example new DisputeTransactionType(model.disputeTransactionType[0]);
 * 
 * @property {NUMBER} _id - The id of the dispute transaction type
 * @property {STRING} _description - The description of the dispute transaction type
 */
export default class DisputeTransactionType extends BCMSRecord {
    _id;
    _description;

    constructor(record) {
        super(record);
    }
}

DisputeTransactionType.define({
    "recordType" : "disputeTransactionTypes",
    "recordIDProp" : "id",
    "className" : "DisputeTransactionType",
    "recordProperties" : [
        /**
         * @name id
         * @instance
         * @property get {STRING} - gets the id of the dispute transaction type
         * @property set {STRING} - sets the id of the dispute transaction type
         * @memberof TravelPlan
         */
        BCMSRecordProperty.mapToString("id", "_id"),

        /**
         * @name description
         * @instance
         * @property get {STRING} - gets the description of the dispute transaction type
         * @property set {STRING} - sets the description of the dispute transaction type
         * @memberof TravelPlan
         */
        BCMSRecordProperty.mapToString("description", "_description"),
    ]
});